import TipoRestaurante from "./TipoRestaurante";
import {DiaFuncionamento} from "./DiaFuncionamento";

export default class PreCadastro {

    email?: string;
    nome?: string;
    cpf?: string;
    telefone?: string;

    senha?: string;
    confirmarSenha?: string;
    jaExisteUsuario?: boolean;

    nomeEstabelecimento?: string;
    cnpjCpfEstabelecimento?: string;

    cep?: string;
    numeroEstabelecimento?: string;
    enderecoCompleto?: string;
    latitude?: number;
    longitude?: number;

    tipoRestaurante?: TipoRestaurante;
    atendimento?: "Presencial" | "Delivery";
    diaFuncionamento?: DiaFuncionamento;
    abertura?: string;
    fechamento?: string;

    logo?: string;

}